
import axios from 'axios'
import {
    getServerHost, getMediaServer, getCookie
} from '../utils';
import {GET_CAM_ID} from '../config'

import {
    config,
    ENDPOINT_AUTHENTICATE
}  from '../config'

const buildURL = (endpoint: string) => {
    const serverHost = getServerHost();
    return `${serverHost}${config.baseAPIURI}${endpoint}`;
};

export const buildMediaURL = (endpoint: string) => {
  
   const mediaServer = getMediaServer();
   const camId = GET_CAM_ID();
   const token = getCookie("auth_token");
   return `${mediaServer}${endpoint}?camId=${camId}&access_id=${token}`;
};

export const AUTHENTICATE = 'AUTHENTICATE';
export const AUTHENTICATE_SUCCESS = 'AUTHENTICATE_SUCCESS';
export const AUTHENTICATE_FAILURE = 'AUTHENTICATE_FAILURE';

function authenticate() {
    return (dispatch: Function, getState: Function) => {
        dispatch({
            type: AUTHENTICATE,
        });

        return axios({
            url: buildURL(ENDPOINT_AUTHENTICATE()),
            method: 'post',
            data: {
            },
        })
            .then(payload => dispatch({
                type: AUTHENTICATE_SUCCESS,
                payload
            }))
            .catch((error) =>
                dispatch({
                    type: AUTHENTICATE_FAILURE,
                    // payload: {
                    //     message: get(error, 'response.data', get(error, 'message', 'Authentication failed')),
                    //     status: get(error, 'response.status', '')
                    // },
                }),
            )
    }
}

// @ts-ignore
function ensureAuthenticated() {
    return async (dispatch: Function, getState: Function) => {
        // const state: {} = getState();

        // if (isAuthenticated(state)) {
        //     return
        // }

        return await dispatch(authenticate())
    }
}

/**
 * This action is supposed to be used for API invocation across
 * the front-end codebase.
 *
 * @param endpoint {string} - API endpoint, e.g. `/nodes`
 * @param pOptions {object} - API invocation options. It's an object with `method` and `data` as possible keys
 */

export function authRequest(endpoint: string, pOptions: object = {}) {
    const url = buildURL(endpoint);
    const token = getCookie("auth_token");
    const options = {
        method: 'get',
        data: {},
        delay: 0,
        headers: {"Authorization" : `Bearer ${token}`},
        ...pOptions
    };
    const { method, data, headers } = options;

    return async (dispatch: Function, getState: Function) => {
        await new Promise(resolve => setTimeout(resolve, options.delay));

        // await dispatch(ensureAuthenticated())

        // const token = getAuthToken(getState())
        return axios({
            url,
            method,
            data,
            headers: {
                ...headers
            }
        })
    }
}




// WEBPACK FOOTER //
// ./src/actions/auth.ts